
import { CONFIDENCE, RANKS } from '../fieldOptions';
import { btnStyle, gridStyle, inputStyle, labelStyle, stepDescStyle } from '../styles';

/**
 * What it is, if anybody knows.
 *
 * All of it is optional: a collection may be saved with no name, with a rank
 * alone, or as Unknown, and one submitted without a name goes to the experts.
 * What is not optional is that a name which was TYPED must have been chosen
 * from the dictionary (collections/wizardRules.js), so a misspelling cannot
 * become a taxon. Changing the rank empties the box for the same reason: a
 * name chosen as a species is not a genus.
 */
export default function Step4({
  t, user, form, onFormChange, onRankChange, taxon, taxonSelected, onTaxonPick,
  onMarkUnknown,
}) {
  const visibleTaxonSuggestions = form.current_rank
    ? taxon.suggestions.filter(t => t.taxonomic_rank === form.current_rank)
    : taxon.suggestions;
  const rankFilteredEmpty = !!form.current_rank && taxon.suggestions.length > 0 && visibleTaxonSuggestions.length === 0;

  return (
  <div>
    <p style={stepDescStyle}>{t('step4.desc')}</p>
    <div style={gridStyle}>
      <label style={labelStyle}>
        {t('step4.rankLabel')}
        <select name="current_rank" title={t('tip.rankWizard')} value={form.current_rank} onChange={onRankChange} style={inputStyle}>
          <option value="">{t('common:selectPlaceholder')}</option>
          {RANKS.map(r => <option key={r} value={r}>{t(`common:rank.${r}`)}</option>)}
        </select>
      </label>
      <label style={labelStyle}>
        {t('step4.nameLabel')}
        <div style={{ position: 'relative' }}>
          <input
            data-testid="wizard-taxon"
            title={t('tip.taxonSearch')}
            value={taxon.query}
            onChange={taxon.onChange}
            onBlur={() => setTimeout(() => taxon.close(), 150)}
            placeholder={t('step4.namePlaceholder')}
            style={{ ...inputStyle, fontStyle: taxonSelected ? 'italic' : 'normal' }}
            autoComplete="off"
            dir="ltr"
          />
          {taxon.open && visibleTaxonSuggestions.length > 0 && (
            <ul style={{
              position: 'absolute', top: '100%', insetInlineStart: 0, insetInlineEnd: 0, zIndex: 200,
              background: 'var(--c-surface)', border: '1px solid var(--c-border-strong)', borderRadius: 6,
              margin: 0, padding: 0, listStyle: 'none',
              maxHeight: 200, overflowY: 'auto',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            }}>
              {visibleTaxonSuggestions.map(sugg => (
                <li key={sugg.taxon_id}
                  data-testid="wizard-taxon-suggestion"
                  onMouseDown={() => onTaxonPick(sugg.scientific_name)}
                  style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid var(--c-bg-muted)' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--c-primary-soft)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'var(--c-surface)'}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }} dir="ltr">
                    <span style={{ fontStyle: 'italic' }}>{sugg.scientific_name}</span>
                    {sugg.taxonomic_rank && (
                      <span style={{ fontSize: 11, color: 'var(--c-text-muted-fg)', marginInlineStart: 8 }}>{sugg.taxonomic_rank}</span>
                    )}
                  </div>
                  {sugg.hebrew_name && (
                    <div dir="rtl" style={{ fontSize: 12, color: 'var(--c-text-muted-fg)', marginTop: 2 }}>{sugg.hebrew_name}</div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
        {(taxon.noMatch || rankFilteredEmpty) && taxon.query.length >= 2 && (
          <span style={{ display: 'block', marginTop: 5, fontSize: 12, color: 'var(--c-danger-fg)' }}>
            {(user?.roles || []).some(r => r === 'internal_expert' || r === 'collection_manager')
              ? t('step4.noMatchExpert')
              : t('step4.noMatchOther')}
          </span>
        )}
        <button type="button" onClick={onMarkUnknown} title={t('tip.markUnknown')}
          style={{ ...btnStyle('var(--c-text-muted)'), fontSize: 12, padding: '4px 10px', marginTop: 6 }}>
          {t('step4.markUnknown')}
        </button>
      </label>
      <label style={labelStyle}>
        {t('step4.confidenceLabel')}
        <select name="current_confidence" title={t('tip.confidence')} value={form.current_confidence} onChange={onFormChange} style={inputStyle}>
          <option value="">{t('common:selectPlaceholder')}</option>
          {CONFIDENCE.map(c => <option key={c} value={c}>{t(`common:confidence.${c}`)}</option>)}
        </select>
      </label>
    </div>
    {form.current_rank === 'unknown' && (
      <div style={{ background: 'var(--c-info-soft-2)', border: '1px solid var(--c-info-border)', borderRadius: 6, padding: '10px 14px', fontSize: 13, color: 'var(--c-info-3-fg)' }}>
        {t('step4.unknownRankNotice')}
      </div>
    )}
  </div>
  );
}
